import { IRootReducer } from 'redux/rootReducer'

export const getUser = (state: IRootReducer) => state.user.user
export const getError = (state: IRootReducer) => state.user.error
export const isLoading = (state: IRootReducer) => state.user.isLoading
export const isAuthorized = (state: IRootReducer) => state.user.isAuthorized

export const getUserProperty = (state: IRootReducer, property: string) =>
  (getUser(state) as IUser)[property]
